import { createSelector } from "reselect";
import { RootState } from "../../../redux/store";

const getAllBrand = (state: RootState) => state.brand_reducer;
export const getAllBrandSelector = createSelector(
  [getAllBrand],
  (brands) => brands?.brand_data
);
